import { AlertCircle, AlertTriangle } from "lucide-react";

import { cn } from "../../lib/utils";

import type { LucideIcon } from "lucide-react";

type StatusTone = "warning" | "error";

interface StatusCardProps {
  title: string;
  description?: string;
  tone?: StatusTone;
  className?: string;
}

const TONE_STYLES: Record<
  StatusTone,
  { icon: LucideIcon; badge: string; glyph: string }
> = {
  warning: {
    icon: AlertTriangle,
    badge:
      "border-amber-200 bg-amber-50 dark:border-amber-800/40 dark:bg-amber-950/30",
    glyph: "text-amber-500 dark:text-amber-400",
  },
  error: {
    icon: AlertCircle,
    badge: "border-red-200 bg-red-50 dark:border-red-800/40 dark:bg-red-950/30",
    glyph: "text-red-500 dark:text-red-400",
  },
};

export const StatusCard = ({
  title,
  description,
  tone = "warning",
  className,
}: StatusCardProps) => {
  const { icon: Icon, badge, glyph } = TONE_STYLES[tone];

  return (
    <div
      className={cn("flex w-full items-center justify-center p-8", className)}
    >
      <div className="flex max-w-md flex-col items-center gap-6 rounded-2xl border bg-card p-10 text-center shadow-sm">
        <div
          className={cn(
            "flex h-16 w-16 items-center justify-center rounded-2xl border",
            badge,
          )}
        >
          <Icon className={cn("h-8 w-8", glyph)} />
        </div>
        <div className="space-y-2">
          <h2 className="text-xl font-semibold tracking-tight">{title}</h2>
          {description && (
            <p className="text-sm leading-relaxed text-muted-foreground">
              {description}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};
